import { configureStore } from '@reduxjs/toolkit';
import calculationReducer from './features/calculations/calculationSlice';

export const store = configureStore({
	reducer: {
		calculations: calculationReducer,
	},
});
